import React from 'react';
import MainMap from './MainMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchRegionsAndPassIntoState, getRussianStatAndPassIntoState } from '../API';

export default class Main extends React.Component {

  constructor() {
    super();
    this.state = {
      data: [],
      russianStat: {},
      worldStat: {},
      regionsStat: [],
      selectValue: 14,
    };
  }

  componentDidMount() {
    fetchRegionsAndPassIntoState(this);
    getRussianStatAndPassIntoState(this);
  }

  getRegion() {
    return this.state.regionsStat.filter(e => {
      return parseInt(e.id) === parseInt(this.state.selectValue);
    })[0];
  }

  render() {
    return (
      <div className='content'>
        <div className='mainmap'>
          <MainMap data={this.state.data} />
          <div className='mapbackground'></div>
        </div>
        <div className='maincontent'>
          <p className='rightnow'>Прямо сейчас в России:</p>
          <div className='stat'>
            <table>
              <tbody>
                <tr>
                  <td className='label infected'>Заражено:</td>
                  <td>{this.state.russianStat.total}</td>
                </tr>
                <tr>
                  <td className='label dead'>Умерло:</td>
                  <td>{this.state.russianStat.deaths}</td>
                </tr>
                <tr>
                  <td className='label cured'>Выздоровело:</td>
                  <td>{this.state.russianStat.cured}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div 
            onClick={() => {
              let iterations = 0;
              requestAnimationFrame(animate);
              function animate() {
                window.scrollBy(0, 10);
                if (iterations < 120) {
                  iterations+=10;
                  requestAnimationFrame(animate);
                }
              }
            }}
            className='downplease'
            style={{
              display: this.props.topBarHidden ? 'none' : 'block',
            }}
            >
            <p>Смотреть подробную статистику</p>
            <FontAwesomeIcon
              icon='arrow-down'
              />
          </div>
          
          <div
            className='details'
            style={{
              display: this.props.topBarHidden ? 'block' : 'none',
            }}
            >
            <p className='rightnow'>Прямо сейчас в мире:</p>
            <div className='stat'>
              <table>
                <tbody>
                  <tr>
                    <td className='label infected'>Заражено:</td>
                    <td>{this.state.worldStat.total}</td>
                  </tr>
                  <tr>
                    <td className='label dead'>Умерло:</td>
                    <td>{this.state.worldStat.deaths}</td>
                  </tr>
                  <tr>
                    <td className='label cured'>Выздоровело:</td>
                    <td>{this.state.worldStat.cured}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className='rightnow'>Прямо сейчас в Вашем регионе:</p>
            <select 
              className='selectregion' 
              value={this.state.selectValue}
              onChange={(e) => this.setState({
                selectValue: e.target.value,
              })}>
              {this.state.regionsStat.map(e => 
                <option value={e.id}>{e.province}</option>
                )}
            </select>
            <div className='stat'>
              <table>
                <tbody>
                  <tr>
                    <td className='label infected'>Заражено:</td>
                    <td>{this.getRegion() ? this.getRegion().total : '0'}</td>
                  </tr>
                  <tr>
                    <td className='label dead'>Умерло:</td>
                    <td>{this.getRegion() ? this.getRegion().deaths : '0'}</td>
                  </tr>
                  <tr>
                    <td className='label cured'>Выздоровело:</td>
                    <td>{this.getRegion() ? this.getRegion().cured : '0'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>



        </div>
      </div>
    )
  }
}
